module.exports = __webpack_public_path__ + "static/media/getresult.ab3cca5a.png";